export default "__VITE_ASSET__DOFy6Vq1__"